import React, { useEffect } from 'react'

import {
  getGetAllCategoriesInLocation,
  getGetAllProductsInLocation,
} from '../../lib/sanity.client'
import { PageBanner } from '../../components/PageBanner'
import { Description } from '../shared/Description'
import PageHead from '../shared/PageHead'
import { FAQ } from '../shared/FAQ'
import { TravelPlanWidget } from '../shared/TravelPlanWidget'
import TileSlider from '../structure/TileSlider'
import { DynamicFooter } from '../footer/DynamicFootes'
import { getAlternates } from '../../lib/helper/helper'
import CustomGrid from '../structure/CustomGrid'
import { Widget } from '../shared/Widget'
import { useLocationContext } from '../context/LocationContext'

interface Props {
  location: MajorLocation
}

export function Location({ location }: Props) {
  const { setLocationData } = useLocationContext()
  const {
    _type,
    name,
    nameDescription,
    h1,
    coverImage,
    _id,
    description_1,
    description_2,
    description_3,
    faq,
    travelPlanWidget,
    reviews,
    meta_title,
    meta_description,
    number_activities,
    number_locations,
    dynamicFooter,
    product_link,
  } = location

  useEffect(() => {
    setLocationData(_id, name)
  }, [_id, name, setLocationData])

  return (
    <>
      <PageHead
        meta_title={meta_title}
        meta_description={meta_description}
        alternates={getAlternates(location)}
        item={location}
        coverImage={coverImage}
        wildcards={{ number_activities, number_locations }}
        faqs={faq}
      />
      <PageBanner
        coverImage={coverImage}
        name={name}
        nameDescription={nameDescription}
        h1={h1}
        wildcards={{ number_activities, number_locations }}
        product_link={product_link}
      />
      <TileSlider
        loadWith={getGetAllCategoriesInLocation(_id)}
        type={'category'}
      />
      <CustomGrid
        componentInBetween={
          travelPlanWidget && <TravelPlanWidget widget={travelPlanWidget} />
        }
        loadWith={getGetAllProductsInLocation(_type, _id)}
        location={name}
        showWidgetIfEmpty
        widgetTopic={name}
        addAsSchema
      />
      {description_1 && !!description_1.length && (
        <Description
          description={description_1}
          withBorder
          nameLocation={name}
          {...reviews}
        />
      )}
      {description_2 && !!description_2.length && (
        <Description description={description_2} withBorder />
      )}
      {description_3 && !!description_3.length && (
        <Description description={description_3} withBorder />
      )}
      {!!faq?.length && faq !== null && <FAQ faqs={faq} nameEntity={name} />}
      {travelPlanWidget?.global_link && (
        <TravelPlanWidget widget={travelPlanWidget} />
      )}
      {product_link && (
        <Widget
          product_link={product_link}
          coverImage={coverImage}
          name={name}
        />
      )}
      <DynamicFooter dynamicFooter={dynamicFooter} location={name} />
    </>
  )
}
